module.exports = __webpack_public_path__ + "media/customizations/pomonalife/back-c7ae83b496a42309b4ce70a02fecc176.jpg";